import { authPillButtonClass, authSecondaryButtonClass, Button, Icons } from '@longy/web-components'
import { createFileRoute, getRouteApi, Link } from '@tanstack/react-router'
import { Check, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthLayout } from '../../components/auth/AuthLayout'
import { api } from '../../core/trpc'

const PATH = '/confirm-email/$code'
const routeApi = getRouteApi(PATH)

const ConfirmEmailPage = () => {
    const { t } = useTranslation()
    const { code } = routeApi.useParams()

    const [isLoading, setIsLoading] = useState(true)
    const [isSuccess, setIsSuccess] = useState(false)

    const { mutateAsync: confirmEmail } = api.user.confirmEmail.useMutation()

    useEffect(() => {
        const confirm = async () => {
            try {
                await confirmEmail({ code })
                setIsSuccess(true)
            } catch {
                setIsSuccess(false)
            } finally {
                setIsLoading(false)
            }
        }

        confirm()
    }, [code, confirmEmail])

    const title = isLoading
        ? undefined
        : isSuccess
          ? t('app.registration.emailConfirmed')
          : t('app.registration.confirmEmailError')

    return (
        <AuthLayout title={title}>
            {isLoading ? (
                <div className="flex justify-center">
                    <Icons.Spinner className="size-12 animate-spin text-primary" />
                </div>
            ) : isSuccess ? (
                <div className="flex flex-col items-center gap-4">
                    <div className="rounded-full border-4 border-primary p-3">
                        <Check className="size-12 text-primary" />
                    </div>
                    {/*
                     * The existing key says to log in *in the mobile app*, which is no
                     * longer the only option. Its value cannot be edited in place — the
                     * seeder only ever adds keys — so a new key carries the new wording and
                     * the old one is left where it is.
                     */}
                    <p className="text-center text-brand-gray">
                        {t('frontend.auth.emailConfirmedYouCanLogIn')}
                    </p>
                    <Button asChild className={authPillButtonClass}>
                        <Link to="/login">{t('frontend.auth.login')}</Link>
                    </Button>
                </div>
            ) : (
                <div className="flex flex-col items-center gap-4">
                    <div className="rounded-full border-4 border-destructive p-3">
                        <X className="size-12 text-destructive" />
                    </div>
                </div>
            )}

            <Button asChild className={authSecondaryButtonClass} variant="outline">
                <a href="/">{t('common.ui.back')}</a>
            </Button>
        </AuthLayout>
    )
}

export const Route = createFileRoute(PATH)({
    head: () => ({
        meta: [{ title: 'Long-Y - E-mail megerősítés' }],
    }),
    component: ConfirmEmailPage,
})
